import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from 'components/common/Breadcrumb';
import Thumbnail from 'components/common/Thumbnail';
import Masonry from 'react-masonry-component';
import './Works.css';
import { MQSpecial1 } from 'utils/responsive-mq';
import MyHelmet from 'components/common/MyHelmet';

const WorksComponent = (props) => {
	return (
		<div id="Page_Works" className="Page">
			<MyHelmet
				title={props.breadcrumb[props.breadcrumb.length - 1].title}
				// description={description}
			/>{/* TODO: BAD */}

			<div className="wrap">
				<Breadcrumb items={props.breadcrumb} />
				{ props.items &&
					<MQSpecial1>
						{(match) => {
							return (match)? 
							<GridList items={props.items} /> :
								<MasonryList items={props.items} />;
						}}
					</MQSpecial1>
				}
				{ !props.items && props.loaded &&
					<h5>No result.</h5>
				}
			</div>
		</div>
	)
}
WorksComponent.propTypes = {
	loaded: PropTypes.bool,
	items: PropTypes.array,
	breadcrumb: PropTypes.array,
}
export default WorksComponent;


const GridList = ({items}) => {
	if (!items) return null;

	const thumbnails = items.map( item => {
		const info = formatInfo( item );
		return <div key={item.slug} className="GridItem"><Thumbnail {...info} /></div>
	} );
	
	return <div className="GridList">{thumbnails}</div>
}
const MasonryList = ({items}) => {
	if (!items) return null;
	
	const thumbnails = items.map( item => {
		const info = formatInfo( item );
		return <div key={item.slug} style={{width: '50%'}}><Thumbnail {...info} /></div>
	} );
	
	return (
		<div className="MasonryList">
			<Masonry options={{percentPosition: true}}>{thumbnails}</Masonry>
		</div>
	)
}

const formatInfo = ( item ) => {
	const baseInfo = {
		slug: item.slug,
		title: item.title,
		row2: item.row2,
	}
	const image = item.coverImageAlt || item.coverImage;
	
	return (image) 
		? { ...baseInfo, 
			src: image.src,
			width: image.width,
			height: image.height,
			hex: item.prominentColorOfCoverImage }
		: baseInfo;
}


// WEBPACK FOOTER //
// ./src/components/Pages/Works/WorksComponent.jsx